import React, { useEffect } from 'react';
import {
  Card,
  CardContent,
  Button,
  CardActions,
  Box
} from '@material-ui/core';
import ProjectDetails from 'Projects/components/ProjectDetails';
import {
  useCanSave,
} from 'Projects/store';
import usePageTitle from 'Projects/hooks/usePageTitle';
import useSave from '../hooks/useSave';
import {
  useNavTab,
} from '../store';

const Details = () => {
  const [, setNavTab] = useNavTab();
  const { save } = useSave();
  usePageTitle('Project Details');

  const [canSaveDevice] = useCanSave();

  useEffect(() => {
    setNavTab('details');
  }, []);

  return (
    <Box p={2}>
      <Card>
        <CardContent>
          <ProjectDetails />
        </CardContent>
        <CardActions>
          <Box flex="auto" />
          <Button color="primary" variant="contained" onClick={save} disabled={!canSaveDevice}>
            Save
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default Details;
